// Builds the public short URL that admins copy to clipboard for sharing.
// The URL is always https://gtlst.me/${nano_id} regardless of which
// shortener mapping exists in the database — that contract is owned by
// the publish flow, not by this helper. Callers must verify that the
// property is actually shareable (status === 'published' + nano_id
// present) before offering the copy affordance.

export const GTLST_ME_BASE_URL = 'https://gtlst.me';

export function getPropertyShareUrl(nanoId: string | undefined | null): string | null {
    if (typeof nanoId !== 'string') return null;
    const trimmed = nanoId.trim();
    if (!trimmed) return null;
    return `${GTLST_ME_BASE_URL}/${trimmed}`;
}
